export default __webpack_public_path__ + "static/media/move_icon.3db3a034.svg";